import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Auth() {
  const navigate = useNavigate();

  useEffect(() => {
    // Auth page is no longer used for token exchange (tokens arrive via hash at origin).
    // Redirect to home.
    navigate("/", { replace: true });
  }, [navigate]);

  return <div>Redirecting…</div>;
}
